<template>
    <div class="container__grid">
        <super-checkout-intern-header :view="view" />
        <super-checkout-intern-body :view="view" :show-load-more="showLoadMore"/>
    </div>
</template>

<script>

export default {
    name: "super-checkout-intern",
    props: ["view"],
    data(){
        return {
            t: [],
            loading: false,
            allItems: [],
            params: '',
            meta: null
        }
    },

    mounted () {
        this.handleAllCards();
        // console.log(this.view);
    },

    methods: {
        handleAllCards(params = false, time = false) {
            var vm = this;
            vm.loading = true;
            // parametros normais
            vm.params = (params ? params : '');

            //select time
            vm.params = (time ? vm.params + '&created=' + time : vm.params);
            
            axios.get(
                this.view.routes.rota_office_super_checkout_intern_request + (vm.params ? '?' + vm.params : ''),
            )
            .then(function (response) {
				vm.loading = false;
				vm.meta = response.data.meta
                vm.allItems = response.data.products;
            })
            .catch(function (error) {
                // handle error
                console.log(2,error);
            })
        },
        handleAllCardsMore() {
            if (this.showLoadMore) {
                var vm = this;
                vm.loading = true;
                axios.get(
                    this.view.routes.rota_office_super_checkout_intern_request + '?' + vm.params + '&page=' + (vm.meta.current_page + 1),
                )
                .then(function (response) {
					vm.loading = false;
					vm.meta = response.data.meta
                    response.data.products.map(el => vm.allItems.push(el));
                })
                .catch(function (error) {
                    // handle error
                    console.log(2,error);
                })
            }
        }
    },

    computed: {
		showLoadMore() {
			return this.allItems.length && this.meta && (this.meta.current_page < this.meta.last_page)
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    .loading-sp {
        border: 8px solid #d0e3f0;
        border-radius: 50%;
        border-top: 8px solid #0294ff;
        width: 50px;
        height: 50px;
        -webkit-animation: spin-sp 1s linear infinite; /* Safari */
        animation: spin-sp 1s linear infinite;
        margin: 0 auto;
        position: relative;
        margin: 1rem auto;
    }

    @keyframes spin-sp {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /* Safari */
    @-webkit-keyframes spin-sp {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }
</style>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// resources/office/js/components/super-checkout-intern/index.vue